


























import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { TEntity } from '@/plugins/podolib/services/entities/Entity';
import { TStation } from '@/plugins/podolib/services/entities/EntityStations';
// Component
import ElementBgIcon from '@/components/elements/ElementBgIcon.vue';

@Component({
  components: {
    ElementBgIcon,
  },
})
export default class DialogStartAnalysisWithoutConnectedStation extends Vue {
  @Prop({ default: false }) openDialog!: boolean;

  // Is an analysis in progress ?
  get isInProgressAnalysis() {
    return Vue.prototype.$pdc.analysis.manifestHasData;
  }

  closeNoStationDialog() {
    this.$emit('closeNoStationDialog');
  }
}
